const baseURL = 'https://217.77.13.31:8888';

export const createAtelierRegistration = async (registrationData) => {
    console.log(registrationData)
    const response = await fetch(`${baseURL}/create-atelier-registration`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(registrationData),
    });
    console.log(JSON.stringify(response))
    if (response.ok) {
      const data = await response.json();
      return data;
    }
  };

export const getAllRegistrations = async () => {
    const response = await fetch(`${baseURL}/get-atelier-registrations`);
    if (response.ok) {
        const data = await response.json();
        return data;
    }
    throw new Error('Failed to fetch registrations');
};